import { orderServiceInstance as axiosInstance } from "@stadium/services/axios";

import { jsonDataFormatter } from "@stadium/helpers/formatter";
import {
  formatOrderUpdateErrors,
  formatOrder,
  formatOrderCheckoutErrors,
} from "@stadium/checkout/src/helpers/order";
import { showErrorToast } from "@stadium/services/react-toastify";
import { withSkipContacts } from "@stadium/helpers/form/utils";

import {
  INVALID_PROMO_STATUS_CODE,
  UPDATE_ORDER_ERROR_TOAST_ID,
  SM_PROGRAM_ID,
} from "@stadium/checkout/src/constants/order";

const { post, patch, get, put } = axiosInstance;

export const applyCouponCodeApi = ({ orderId, couponCode, successCb, errorCb }) =>
  post(`orders/${orderId}/apply_coupon_code`, { coupon_code: couponCode })
    .then((res) => {
      if (res.successful) {
        successCb?.();
      }
      return res;
    })
    .catch((error) => {
      if (INVALID_PROMO_STATUS_CODE.includes(error?.response?.data?.status_code)) {
        errorCb("Code does not match active promo codes");
      } else errorCb(error?.response?.data?.error);
    });

export const removeCouponCodeApi = ({ orderId, couponCode, successCb, errorCb }) =>
  post(`orders/${orderId}/remove_coupon_code`, {
    coupon_code: couponCode,
  })
    .then((res) => {
      if (res.successful) {
        successCb?.();
      }
      return res;
    })
    .catch((error) => {
      errorCb(error?.response?.data?.error);
    });

export const fetchOrderInvoice = (number) =>
  get(
    `/orders/${number}/invoice.pdf`,
    {
      program_id: SM_PROGRAM_ID,
    },
    { responseType: "blob" },
  );

export const updateOrderDetails = ({
  orderId,
  orderData,
  responseType = "",
  additionalOrderParams = {},
}) =>
  patch(
    `/orders/${orderId}`,
    withSkipContacts({
      order: { ...orderData },
      ...(responseType && { response_type: responseType }),
      ...additionalOrderParams,
    }),
  )
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      const orderData = formatOrder(responseData);
      return orderData;
    })
    .catch((error) => {
      const errors = formatOrderUpdateErrors(error?.response?.data);
      if (errors.length) {
        errors.forEach((err, index) =>
          showErrorToast({
            message: err,
            config: { toastId: `${UPDATE_ORDER_ERROR_TOAST_ID}-${index}` },
          }),
        );
      }
      throw error;
    });

export const updateUserTreat = async ({ number, data, additionalOrderParams = {} }) =>
  patch(
    `/orders/${number}/update_treat`,
    withSkipContacts({
      order: {
        ...data,
      },
      ...additionalOrderParams,
    }),
  )
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      const orderData = formatOrder(responseData);
      return orderData;
    })
    .catch((error) => {
      const errors = formatOrderUpdateErrors(error?.response?.data);
      if (errors.length) {
        errors.map((err) => showErrorToast({ message: err }));
      }
      throw error;
    });

export const createOrder = async (payload) =>
  post("/orders", withSkipContacts(payload))
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      const orderData = formatOrder(responseData);

      return orderData;
    })
    .catch((error) => {
      throw error;
    });

export const refreshTotals = async (orderId, payload = {}) =>
  patch(
    `/orders/${orderId}/refresh_totals`,
    withSkipContacts({
      program_id: SM_PROGRAM_ID,
      ...payload,
    }),
  )
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      const orderData = formatOrder(responseData);
      return orderData;
    })
    .catch((error) => {
      throw error;
    });

export const updateTreatDetail = (number, payload) =>
  patch(`/orders/${number}/update_treat_detail`, withSkipContacts(payload))
    .then((res) => {
      const responseData = jsonDataFormatter(res);
      const orderData = formatOrder(responseData);
      return orderData;
    })
    .catch((error) => {
      const errors = formatOrderUpdateErrors(error?.response?.data);
      if (errors.length) {
        errors.forEach((err) => showErrorToast({ message: err }));
      }
      throw error;
    });

export const checkout = (orderId, payload) =>
  put(`/orders/${orderId}/checkout`, payload)
    .then((response) => {
      const responseData = jsonDataFormatter(response);
      const orderData = formatOrder(responseData);
      return orderData;
    })
    .catch((error) => {
      const errors = formatOrderCheckoutErrors(error?.response?.data);
      if (errors.length) {
        errors.forEach((err) => showErrorToast({ message: err }));
      }
      throw error;
    });
